import { forwardRef } from 'react'

import {
  type BadgeProps,
  Badge as DsBadge,
} from '@enechain/ecloud-designsystem'

/**
 * [DS差異] DS の neutral の地 (`Surface.neutralMid`) は表の偶数行の縞 (`Surface.tertiary`) と同じ
 * #efefef で、縞の行ではバッジの形が見えない。縞の色は変えず、neutral のバッジだけ
 * `Border.lowEmphasis` の 1px の枠を付ける (表の外のバッジも同じ)。内側の影で描くので高さ・幅は増えない。
 */
const NEUTRAL_BADGE_OUTLINE = 'inset 0 0 0 1px {colors.Border.lowEmphasis}'

/**
 * DS の `Badge` と同じ props を受け、`status="neutral"` の時だけ枠を足す。DS の Badge は status を
 * DOM に出さないので、全体の CSS では neutral だけを選べず、部品の入口で足す。
 */
export const Badge = forwardRef<HTMLSpanElement, BadgeProps>((props, ref) => (
  <DsBadge
    ref={ref}
    {...(props.status === 'neutral'
      ? { boxShadow: NEUTRAL_BADGE_OUTLINE }
      : {})}
    {...props}
  />
))
Badge.displayName = 'Badge'
